const modules = {}
   
function parseDom(dom) {
    const elements = dom.querySelectorAll('[data-module]');
    init(elements);
}

function addModule(name, module) {
    if (!modules.hasOwnProperty(name)) {
        modules[name] = module;
    }
}

function init(elements) {
    elements.forEach(element => {
        const module = modules[element.dataset.module];
        if (!module) {
            console.warn(`Module "${element.dataset.module}" could not be found. Did you forget to add it to the loader?`);
            return;
        }
        const instance = new module(element);
        instance.init();
    });
}

document.addEventListener('DOMContentLoaded', (e) => {
    parseDom(e.target);
});

export default {
    add: addModule,
    parseDom: parseDom,
    init: init
}